module.exports = __webpack_public_path__ + "img/logoSM.0a198cbd.png";